import xmlescape from 'xml-escape'

export function boxSticker(text: string) {
  return `<?xml version="1.0" encoding="utf-8"?>
    <DieCutLabel Version="8.0" Units="twips">
        <PaperOrientation>Landscape</PaperOrientation>
        <Id>LargeAddress</Id>
        <IsOutlined>false</IsOutlined>
        <PaperName>30321 Large Address</PaperName>
        <DrawCommands>
            <RoundRectangle X="0" Y="0" Width="2025" Height="5020" Rx="270" Ry="270" />
        </DrawCommands>
        <ObjectInfo>
            <TextObject>
                <Name>TEKST</Name>
                <ForeColor Alpha="255" Red="0" Green="0" Blue="0" />
                <BackColor Alpha="0" Red="255" Green="255" Blue="255" />
                <LinkedObjectName />
                <Rotation>Rotation0</Rotation>
                <IsMirrored>False</IsMirrored>
                <IsVariable>False</IsVariable>
                <GroupID>-1</GroupID>
                <IsOutlined>False</IsOutlined>
                <HorizontalAlignment>Center</HorizontalAlignment>
                <VerticalAlignment>Middle</VerticalAlignment>
                <TextFitMode>AlwaysFit</TextFitMode>
                <UseFullFontHeight>True</UseFullFontHeight>
                <Verticalized>False</Verticalized>
                <StyledText>
                    <Element>
                        <String xml:space="preserve">${xmlescape(text)}</String>
                        <Attributes>
                            <Font Family="Arial" Size="12" Bold="False" Italic="False" Underline="False" Strikeout="False" />
                            <ForeColor Alpha="255" Red="0" Green="0" Blue="0" HueScale="100" />
                        </Attributes>
                    </Element>
                </StyledText>
            </TextObject>
            <Bounds X="322" Y="57.9999999999999" Width="4343" Height="1882" />
        </ObjectInfo>
    </DieCutLabel>`
}
